import imageOne from '@/assets/images/cities/stJohns1.jpg'
import imageTwo from '@/assets/images/cities/stJohns2.jpg'
import imageThree from '@/assets/images/cities/stJohns3.jpg'

export default {
  imageOne,
  imageTwo,
  imageThree,
  'city': 'St. John\'s',
  'writeup': `Unfortunately our St. John's Location is currently unavailable. Sorry for the inconvenience.`,
  'notaries': [
    {
      'name': '',
      'open': false,
      'phone': '',
      'hours': {
        'monday': 'Closed',
        'tuesday': 'Closed',
        'wednesday': 'Closed',
        'thursday': 'Closed',
        'friday': 'Closed',
        'saturday': 'Closed',
        'sunday': 'Closed'
      },
      'address': '',
      'notes': 'Service Currently Unavailable'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/store/provinces/newfoundlandLabrador/cities/stJohns.js